/**
 * Valida um CPF.
 * @param cpf - CPF no formato string, com ou sem pontuação.
 * @returns `true` se o CPF for válido, caso contrário `false`.
 */
export function isValidCPF(cpf: string): boolean {
    if (!cpf) return false; // Verifica se o CPF é nulo ou indefinido
    cpf = cpf.replace(/[^\d]/g, ''); // Remove caracteres não numéricos

    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

    let sum = 0;
    for (let i = 0; i < 9; i++) {
        sum += parseInt(cpf[i]) * (10 - i);
    }
    let firstCheckDigit = (sum * 10) % 11;
    if (firstCheckDigit === 10) firstCheckDigit = 0;
    if (firstCheckDigit !== parseInt(cpf[9])) return false;

    sum = 0;
    for (let i = 0; i < 10; i++) {
        sum += parseInt(cpf[i]) * (11 - i);
    }
    let secondCheckDigit = (sum * 10) % 11;
    if (secondCheckDigit === 10) secondCheckDigit = 0;

    return secondCheckDigit === parseInt(cpf[10]);
}

/**
 * Valida um CNPJ.
 * @param cnpj - CNPJ no formato string, com ou sem pontuação.
 * @returns `true` se o CNPJ for válido, caso contrário `false`.
 */
export function isValidCNPJ(cnpj: string): boolean {
    if (!cnpj) return false; // Verifica se o CNPJ é nulo ou indefinido
    cnpj = cnpj.replace(/[^\d]/g, ''); // Remove caracteres não numéricos

    if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) return false;

    const validateDigit = (cnpj: string, length: number): boolean => {
        let sum = 0;
        let pos = length - 7;
        for (let i = 0; i < length; i++) {
            sum += parseInt(cnpj[i]) * pos--;
            if (pos < 2) pos = 9;
        }
        let checkDigit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
        return checkDigit === parseInt(cnpj[length]);
    };

    return validateDigit(cnpj, 12) && validateDigit(cnpj, 13);
}

/**
 * Valida o formato de um CNPJ.
 * @param cnpj - CNPJ no formato string.
 * @returns `true` se o formato for válido, caso contrário `false`.
 */
export function isValidCNPJFormat(cnpj: string): boolean {
    return /^\d{14}$/.test(cnpj);
}
